var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-category section-full"},[_c('grid-view',{attrs:{"type":'staff',"items":_vm.staffs},on:{"pickItem":_vm.pickStaff}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }